import { ElementTransformer } from '@lexical/markdown';
import { $createPageBreakNode, $isPageBreakNode, PageBreakNode } from '../../nodes/PageBreakNode';

export const PAGE_BREAK_MARKER = '\\\\newpage';
export const PAGE_BREAK_LINE_RE = /^\s*\\{1,2}newpage\s*$/;

export const PAGE_BREAK: ElementTransformer = {
  dependencies: [PageBreakNode],
  export: node => {
    return $isPageBreakNode(node) ? PAGE_BREAK_MARKER : null;
  },
  regExp: PAGE_BREAK_LINE_RE,
  replace: parentNode => {
    parentNode.replace($createPageBreakNode());
  },
  type: 'element',
};
